export default "__VITE_PUBLIC_ASSET__be58ff9d__"